import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Typography from '@mui/material/Typography';
export const Subtitle = ({ children, ml = 0, mt = 0 }) => {
    return (_jsx(Typography, { ml: ml, mt: mt, color: '#000000', fontSize: '24px', fontWeight: 500, lineHeight: '34.32px', children: children }));
};
